import { autoinject, customAttribute } from 'aurelia-framework';
import { ToggleableAttribute } from 'framework/aurelia_tools/toggleable-attribute';

@autoinject
@customAttribute('af-plhrable')
export class PlhrableCustomAttribute extends ToggleableAttribute {
  private element: HTMLSelectElement;
  valueBinding = null;

  constructor(element: Element) {
    super();
    this.element = element as HTMLSelectElement;
  }

  created(owningView) {
    this.valueBinding = owningView.bindings.find(b => b.target === this.element && b.targetProperty === 'value');
  }

  enabled() {
    this.element.classList.add(CLASS_COMPONENT);
    this.queueRules();
    this.valueBinding
      ? this.valueBinding.targetObserver.subscribe(this.queueRules)
      : this.element.addEventListener('change', this.queueRules);
  }

  disabled() {
    this.valueBinding
      ? this.valueBinding.targetObserver.unsubscribe(this.queueRules)
      : this.element.removeEventListener('change', this.queueRules);
    this.element.classList.remove(CLASS_COMPONENT, CLASS_PLACEHOLDER);
  }

  queueRules = () => window.setTimeout(this.applyRules, 0);

  applyRules = () => this.element.selectedIndex === 0
    ? this.element.classList.add(CLASS_PLACEHOLDER)
    : this.element.classList.remove(CLASS_PLACEHOLDER);
}

const CLASS_COMPONENT = 'af-plhrable';
const CLASS_PLACEHOLDER = 'af-plhrable--placeholder';
